__turbopack_context__.v({
  "body": "lead-time-visual-module__gBidZW__body",
  "days": "lead-time-visual-module__gBidZW__days",
  "daysRose": "lead-time-visual-module__gBidZW__daysRose",
  "daysRoseOver": "lead-time-visual-module__gBidZW__daysRoseOver",
  "leadTimeRose": "lead-time-visual-module__gBidZW__leadTimeRose",
  "pill": "lead-time-visual-module__gBidZW__pill",
  "root": "lead-time-visual-module__gBidZW__root",
  "row": "lead-time-visual-module__gBidZW__row",
  "rowTrack": "lead-time-visual-module__gBidZW__rowTrack",
  "statusBody": "lead-time-visual-module__gBidZW__statusBody",
  "statusCell": "lead-time-visual-module__gBidZW__statusCell",
  "threshold": "lead-time-visual-module__gBidZW__threshold",
  "thresholdLabel": "lead-time-visual-module__gBidZW__thresholdLabel",
});
